module.exports = __webpack_public_path__ + "static/media/logo-footer-black.f0fc32e3.svg";